import styled from 'styled-components';

export const AppContainer = styled.div`
  max-width: 375px;
  min-width: 240px;
  margin: auto;
  padding: ${({ theme }) => `0 ${theme.spacing._20px}`};
  text-align: center;
`;

export const DemoAppContainer = styled.div`
  min-width: 240px;
  margin: auto;
  padding: 0px 2rem 0 10rem;
  text-align: center;
`;
